<template>

	<!-- 弹出向导层 start-->
	<div id="pop" class="pop" v-show="pop_show">
		<span class="pop_bg"></span>

		<div id="pop_bodyup" class="pop_content">
			<!-- 动态查询区生成 -->
			<div class="pop_head_close">
				<a class="close" href="javascript:void(0);" @click="closeshow()"></a>
			</div>
			<div class="row-title">
				<h5>{{title}}&nbsp;&nbsp;
				</h5>
				<div class="row-note">
					<div class="row-item">
						操作说明:1、选择变更方式,入库、转移、报废!。2、点生成单据。3、匹配明细，删除多余数据。
					</div>
					<div class="row-item">
						思路说明:一个费用项目对应一个库存变更。其他费=入库单,维修费=转移单,其他费(费用备注包含<span class="red">报废</span>字样)=报废
					</div>
				</div>

			</div>
			<div class="content_edit row-line">
				<div class="content_edit_item">关联单号:{{sheet_no}}</div>
				<div class="content_edit_item">
					<preselect :inData="checkJson(trans_store)" @com-event="refresh_view_edit" />
				</div>
				<div class="content_edit_item">
					<button class="pre_btn_ok" @click="build_sheet('_add')">
						生成单据
					</button>
				</div>
			</div>

			<div class="row-body">
				<div class="row-left">
					<div class="content_edit_item" style="margin-bottom: 8px;font-weight: bold;font-size: 14px;">匹配业务单据
					</div>
					<table class="dataintable ">
						<tr class="tab_header">
							<td>序号</td>
							<td>业务编号</td>
							<td>状态</td>
						</tr>
						<tr :id="'pop_s_'+item.row_num" v-for="(item,index) in list_s_exp" :key="index"
							@click="sel_row_s(item)">
							<td>{{item.id}}</td>
							<td>{{item.sheet_no}}</td>
							<td>{{item.flag}}</td>
						</tr>
					</table>
				</div>
				<div class="row-mid">
					<div class="inline-row">
						<div class="content_edit_item">
							<button class="pre_btn_ok" @click="refresh_data()">
								刷新
							</button>
							<button class="pre_btn_ok" @click="fun_upd('_add')">
								保存
							</button>
							<button class="pre_btn_ok" @click="fun_upd('_del')">
								删除
							</button>
							<button class="pre_btn_ok" @click="fun_upd('_sub')">
								提交
							</button>
							<button class="pre_btn_ok" @click="fun_upd('_bad')">
								作废
							</button>
							<button class="pre_btn_ok" @click="fun_upd('_check')">
								更新明细
							</button>
							<label
								v-show="sheet_exp!=''">{{sheet_flag}}&nbsp;&nbsp;{{io_flag}}&nbsp;&nbsp;{{sheet_exp}}</label>
						</div>
					</div>
					<div class="inline-row">
						<div class="content_edit_item tab-row" v-for="(r,d) in max_row" :key="d">
							<div class="content_edit_item tab-row" v-if="item.x == r.row" v-for="(item,index) in parm"
								:key="index">

								<component :is="NextTickName(item.type)" :inData="checkJson(item)"
									@com-event="refresh_view_all">
								</component>
							</div>
						</div>
					</div>
					<div class="inline-row mark-detail" v-show="list_detail.length>0">
						<div class="content_edit_item mark-detail-top">
							<label>序号:</label><span>{{item_row_num}}</span>&nbsp;
							<label>编号:</label><span>{{item_no}}</span>&nbsp;
							<label>名称:</label><span>{{item_name}}</span>&nbsp;
							<label>数量:</label><input type="number" v-model="item_qty" />&nbsp;
							<button class="pre_btn_ok" @click="fun_upd_item('_upd')">确定</button>
						</div>
						<table class="dataintable ">
							<tr class="tab_header">
								<td>序号</td>
								<td>物品编号</td>
								<td>物品名称</td>
								<td>数量</td>
								<td>单价</td>
								<td>总额</td>
								<td>备注</td>
								<td class="short0 cen">编辑</td>
							</tr>
							<tr :id="'pop_d_'+item.row_num" v-for="(item,index) in list_detail" :key="index">
								<td>{{item.row_num}}</td>
								<td>{{item.item_no}}</td>
								<td>{{item.item_name}}</td>
								<td>{{item.qty}}</td>
								<td>{{item.price}}</td>
								<td>{{item.amount}}</td>
								<td>{{item.note}}</td>
								<td class="short0 cen">
									<button @click="sel_row_d(item,'_edit')">编辑</button>
									<button @click="sel_row_d(item,'_del')">删除</button>
								</td>
							</tr>
						</table>
					</div>

				</div>
				<div class="row-right">
					<div class="content_edit_item" style="margin-bottom: 8px;">匹配关键字:<span
							class="mark-key">{{check_key}}</span></div>
					<table class="dataintable ">
						<tr class="tab_header">
							<td>序号</td>
							<td>物品编号</td>
							<td>物品名称</td>
							<td>单位</td>
							<td>规格</td>
							<td>当前仓库拥有数量</td>
						</tr>
						<tr :id="'pop_s_'+item.row_num" v-for="(item,index) in list_item" :key="index"
							@click="sel_row_check(item)">
							<td>{{item.row_num}}</td>
							<td>{{item.item_no}}</td>
							<td>{{item.item_name}}</td>
							<td>{{item.unit}}</td>
							<td>{{item.size}}</td>
							<td>{{item.qty}}</td>
						</tr>
					</table>
				</div>
			</div>
		</div>

	</div>



	</div>
	<!-- 弹出向导层 end-->


</template>

<script>
	/*
名称：综合入库、转移、销毁
日期：2023-03-24
作者：hj
目标：
方法 传入参数，
1、查询标识
2、编辑标识
*/

	import api from '@/utils/type.js';
	import {
		Sel_page_and_length,
		Method_Common
	} from '@/utils/loadhttpdata.js';

	import {
		BackSpecial
	} from "@/utils/localstore.js";

	export default {
		name: "pre_editstore_tan",
		components: {
			"pre-table": () => import("../auto/auto_view_table.vue")

		},
		data() {
			return {
				element_loading: false,
				pop_show: false,
				show_btn: true,
				load_url: '',
				load_json: '',
				upd_json: '',
				screenWidth: '',
				screenHeight: '',

				title: '未设置标题',
				sheet_no: '',
				sheet_flag: '',
				sel_action: '',
				upd_action: '',
				row_id: '',
				sel_item: [], //备份点击项目
				sys_date: '',

				max_row: [],
				parm: [], //参数结构
				parm_th: [], //标题
				kw1: '',
				kw2: '',
				kw3: '',

				trans_store: {},

				list_s_exp: [],
				list_item: [],

				// post_select: ''
				d_parm: [], //参数结构
				d_row_id: '',
				d_sys_date: '',
				list_detail: [],

				sheet_exp: '',
				io_flag: '',
				check_key: '',

				item_row_num: 0,
				item_id: 0,
				item_no: '',
				item_qty: 0,
				item_name: ''

			};
		},
		methods: {
			showpop: function(parm) {
				this.pop_show = true;
				var Hg = $(document).height();
				// 设置背景高度
				$(".pop_bg").height(Hg);
				// 设置展示动画 第一次有慢入动作,第二次没有:原因是当前页面被缓存，除非重开
				$(".pop_bg").fadeIn("3000");
				$(".pop_content").fadeIn("3000");
				this.load_data(parm)
			},
			closeshow: function() {
				this.pop_show = false;
				$(".pop_bg").fadeOut("3000");
				$(".pop_content").fadeOut("3000");
				this.screenHeight = 0;
				this.screenWidth = 0;
			},
			NextTickName: function(key) {
				return 'pre' + key;
			},
			checkJson: function(d) {
				let temp = '';
				temp = JSON.stringify(d)
				return temp;
			},
			refresh_view_all: function(d, type) {
				// console.log('编辑方式',d);
				for (let i = 0; i < this.parm.length; i++) {

					if (this.parm[i].key == d.key) {
						if (this.parm[i].type == 'select' || this.parm[i].type == 'radio') {
							this.parm[i].val = d.val;
							this.parm[i].sel_name = d.sel_name;
						} else {
							this.parm[i].val = d.val;
						}
						break;
					}
				}

			},
			refresh_view_edit: function(d) {
				// console.log('新增方式',d);
				switch (d.key) {
					case 'store_flag':
						this.trans_store.val = d.val;
						this.trans_store.sel_name = d.sel_name;
						console.log('选择结果', this.trans_store);

						break;
					default:
						break;
				}


				if (d.key == 'store_flag') {
					switch (d.val) {
						case '1':
							this.io_flag = '入库';
							break;
						case '2':
							this.io_flag = '转移';
							break;
						case '3':
							this.io_flag = '报废';
							break;
						default:
							this.io_flag = '';
							break;
					}
				}


				this.chang_parm();

			},
			load_data: function(res) {
				console.log('传入解析', res);
				this.max_row = [];
				for (let i = 1; i <= 4; i++) {
					let o = {};
					o.row = i;
					this.max_row.push(o);
				}

				this.title = res.title;
				this.sheet_no = res.sheet_no;

				this.trans_store = {
					"name": "变更方式",
					"val": "入库",
					"key": "store_flag",
					"type": "select",
					"sel_action": "",
					"list": [{
						"id": "1",
						"val": "入库"
					}, {
						"id": "2",
						"val": "转移"
					}, {
						"id": "3",
						"val": "报废"
					}],
					"sel_name": "",
					"class": "long1",
					"p": "1",
					"w": "1",
					"r": "0",
					"x": "1"
				};

				// 加载已经生成的单据 
				this.load_build_list();

			},
			build_sheet: function() {
				// console.log('生成单据', this.trans_store);

				if (Number(this.trans_store.val) == 0) {
					this.$message({
						message: '请先选择 变更方式!',
						type: 'warning'
					});
					return
				}

				let d = [];
				d.push(this.sheet_no);
				d.push(this.trans_store.val);

				let r = (Math.random() + '').substring(0, 8);
				// console.log(d);
				let temp_data = '';
				temp_data = Method_Common('_store_car_build_add', 0, '', d, r);

				this.$post(
					api.http_method, temp_data
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					console.log('建立结果', res);
					if (res.data.status == 1) {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});

						this.sheet_exp = res.data.parm.sheet_no;

						this.load_build_list();


					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});
					}
				});

				// 再次加载已经生成的单据 
			},
			load_build_list: function() {
				// console.log('加载已经生成单据列表')
				this.element_loading = true;
				let r = (Math.random() + '').substring(0, 8);
				this.list_s_exp = [];
				this.$post(
					api.http_method, Sel_page_and_length('exp_store_car_build', 1, 100, this.sheet_no, r)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					this.list_s_exp = res[0];
				});

				// 再次加载已经生成的单据 
			},
			sel_row_s: function(d) {
				// console.log('业务数据=', d);
				this.sheet_exp = '';
				this.sheet_flag = '';
				this.io_flag = '';
				this.row_id = 0;
				this.sys_date = '';

				this.item_row_num = 0;
				this.item_id = 0;
				this.item_no = '';
				this.item_qty = 0;

				this.sheet_exp = d.sheet_no;
				this.sheet_flag = d.flag;
				this.io_flag = d.io_flag;
				this.row_id = d.row_id;
				this.sys_date = d.sys_date;

				this.chang_parm(d);

			},
			chang_parm: function(d) {
				// 清空展示数据
				this.sheet_exp = '';
				this.list_detail = [];
				this.list_item = [];

				this.parm = [];
				this.d_parm = [];

				if (typeof(d) === 'undefined' || d == '') {
					// 只有加载了指定项目才继续
					return;
				}
				// console.log('选择业务', d);

				let in_date = '',
					in_store = '',
					out_store = '',
					amount = 0,
					in_id = 0,
					note = '',
					sheet_kc = '';


				for (let key in d) {
					switch (key) {
						case 'sheet_no':
							this.sheet_exp = d[key];
							sheet_kc = d[key];
							break;
						case 'in_date':
							in_date = d[key];
							break;
						case 'out_store':
							out_store = d[key];
							break;
						case 'amount':
							amount = d[key];
							break;
						case 'note':
							note = d[key];
							break;
						case 'in_store':
							in_store = d[key];
							break;
						case 'in_id':
							in_id = d[key];
							break;
						case 'io_flag':
							this.io_flag = d[key];
							this.trans_store.val = d[key];
							break;
						default:
							break;
					}
				}


				switch (this.io_flag) {
					case '入库':
						this.parm = [{
								"name": "业务编号",
								"val": sheet_kc,
								"key": "sheet_no",
								"type": "label",
								"class": "long1",
								"p": "0",
								"w": "0",
								"r": "0",
								"x": "1"
							},
							{
								"name": "入仓",
								"val": in_store,
								"key": "in_store",
								"type": "label",
								"p": "0",
								"w": "0",
								"r": "0",
								"x": "1"
							},
							{
								"name": "入库日期",
								"val": in_date,
								"key": "in_date",
								"type": "date",
								"class": "long1",
								"p": "1",
								"w": "0",
								"r": "0",
								"x": "2"
							},
							{
								"name": "总金额",
								"val": amount,
								"key": "amount",
								"type": "label",
								"class": "long1",
								"p": "0",
								"w": "0",
								"r": "1",
								"x": "2"
							},
							{
								"name": "备注",
								"val": note,
								"key": "note",
								"type": "text",
								"class": "long3",
								"p": "1",
								"w": "0",
								"r": "0",
								"x": "3"
							}
						]
						break;
					case '转移':
						this.parm = [{
								"name": "业务编号",
								"val": sheet_kc,
								"key": "sheet_no",
								"type": "label",
								"class": "long1",
								"p": "0",
								"w": "0",
								"r": "0",
								"x": "1"
							},
							{
								"name": "出仓",
								"val": out_store,
								"key": "out_store",
								"type": "label",
								"p": "0",
								"w": "0",
								"r": "0",
								"x": "1"
							},
							{
								"name": "入仓",
								"val": in_store,
								"key": "in_store",
								"type": "select",
								"sel_action": "_base_storecar2",
								"sel_name": in_store,
								"p": "1",
								"w": "0",
								"r": "0",
								"x": "2"
							},
							{
								"name": "转移日期",
								"val": in_date,
								"key": "in_date",
								"type": "date",
								"class": "long1",
								"p": "1",
								"w": "0",
								"r": "0",
								"x": "3"
							},
							{
								"name": "总金额",
								"val": amount,
								"key": "amount",
								"type": "label",
								"class": "long1",
								"p": "0",
								"w": "0",
								"r": "1",
								"x": "3"
							},
							{
								"name": "备注",
								"val": note,
								"key": "note",
								"type": "text",
								"class": "long3",
								"p": "1",
								"w": "0",
								"r": "0",
								"x": "4"
							}
						]
						break;
					case '报废':
						this.parm = [{
								"name": "业务编号",
								"val": sheet_kc,
								"key": "sheet_no",
								"type": "label",
								"class": "long1",
								"p": "0",
								"w": "0",
								"r": "0",
								"x": "1"
							},
							{
								"name": "入仓",
								"val": out_store,
								"key": "out_store",
								"type": "label",
								"p": "0",
								"w": "0",
								"r": "0",
								"x": "1"
							},
							{
								"name": "入库日期",
								"val": in_date,
								"key": "in_date",
								"type": "date",
								"class": "long1",
								"p": "1",
								"w": "0",
								"r": "0",
								"x": "2"
							},
							{
								"name": "总金额",
								"val": amount,
								"key": "amount",
								"type": "label",
								"class": "long1",
								"p": "0",
								"w": "0",
								"r": "1",
								"x": "2"
							},
							{
								"name": "备注",
								"val": note,
								"key": "note",
								"type": "text",
								"class": "long3",
								"p": "1",
								"w": "0",
								"r": "0",
								"x": "3"
							}
						]
						break;
					default:
						this.$message({
							message: '变更方式异常!',
							type: 'warning'
						});
						break;

				}
				console.log('显示模块', this.parm);

				this.refresh_data();
			},
			refresh_data: function() {
				// this.change_style();
				if (typeof(this.sheet_exp) === 'undefined' || this.sheet_exp == '') {
					this.$message({
						message: '请点击要编辑的业务单据!',
						type: 'warning'
					});
					return;

				}
				this.refresh_main();
				this.refresh_child();
			},
			refresh_main: function() {
				// console.log('加载指定单据sheet_no=' + this.sheet_no);
				this.element_loading = true;
				let r = (Math.random() + '').substring(0, 8);
				this.$post(
					api.http_method, Sel_page_and_length('exp_store_car_build_main', 1, 100, this.sheet_exp)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.length > 0) {
						let t_list_data = res[0];

						let list_main = [];
						for (let i = 0; i < t_list_data.length; i++) {
							let arr = [];
							let temp_no = {};
							for (let j in t_list_data[i]) {
								let o = {};
								o.key = j;
								let temp_str = '';
								temp_str = t_list_data[i][j];
								if (typeof(temp_str) === 'string' && temp_str.indexOf("\\r\\n") > 0) {
									while (temp_str.indexOf('\\r\\n') > 0) {
										temp_str = temp_str.replace("\\r\\n", "\r\n");
									}
								}
								o.val = BackSpecial(temp_str);
								arr.push(o);
							}
							arr.splice(1, 0, temp_no);
							list_main.push(arr);
						}
						// console.log('转换', list_main);
						let ok_data = [];
						ok_data = list_main[0];
						for (let i = 0; i < ok_data.length; i++) {
							for (let j = 0; j < this.parm.length; j++) {
								if (ok_data[i].key == this.parm[j].key) {
									this.parm[j].val = ok_data[i].val;
									break;
								}
							}
						}

					} else {
						this.$message({
							message: '业务单据' + this.sheet_exp + ' 未新建库存管理数据!',
							type: 'warning'
						});
					}
				});
			},
			refresh_child: function() {
				// console.log('加载指定单据sheet_no=' + this.sheet_no);
				this.element_loading = true;
				let r = (Math.random() + '').substring(0, 8);
				this.list_detail = [];
				this.$post(
					api.http_method, Sel_page_and_length('exp_store_car_build_child', 1, 100, this.sheet_exp)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.length > 0) {
						this.list_detail = res[0];
					} else {
						this.$message({
							message: '业务单据' + this.sheet_exp + ' 未匹配到相关明细数据,请点保存更新明细或重新建立匹配关系!',
							type: 'warning'
						});
					}
				});
			},
			fun_upd: function(type) {
				// console.log('操作类型=' + type);
				// console.log('row_id=' + this.row_id + ' sys_date=' + this.sys_date);
				if (type != '_add') {
					if (this.row_id == 0) {
						this.$message({
							message: '请选择要编辑的数据!',
							type: 'warning'
						});
						return;
					}
				}

				let in_date = '',
					in_store = '',
					note = '';
				for (let i = 0; i < this.parm.length; i++) {
					switch (this.parm[i].key) {
						case 'in_date':
							in_date = this.parm[i].val;
							break;
						case 'in_store':
							in_store = this.parm[i].val;
							break;
						case 'note':
							note = this.parm[i].val;
							break;
						default:
							break;
					}
				}

				let d = [];
				d.push(this.sheet_no);
				d.push(this.trans_store.val);
				d.push(this.sheet_exp);

				d.push(in_date);
				d.push(in_store);
				d.push(note);

				let r = (Math.random() + '').substring(0, 8);
				// console.log(d);
				let temp_data = '';
				temp_data = Method_Common('_store_car_build' + type, this.row_id, this.sys_date, d, r);

				this.$post(
					api.http_method, temp_data
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == 1) {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});

						if (type == '_del') {
							// 加载列表
							this.load_build_list();
							this.parm = [];
							this.list_detail = [];

						} else {
							this.row_id = res.data.parm.id;
							this.sys_date = res.data.parm.sys_date;
							// 加载列表
							this.load_build_list();
							// 刷新自己
							this.refresh_data();
						}


					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});
					}
				});

			},
			sel_row_d: function(item, type) {
				// console.log('待核对', item);
				// console.log('操作=' + type);
				this.d_row_id = 0;
				this.d_sys_date = '';
				this.item_row_num = 0;
				this.item_id = 0;
				this.item_no = '';
				this.item_qty = 0;
				this.check_key = '';
				this.item_row_num = item.row_num;
				this.d_row_id = item.row_id;
				this.d_sys_date = item.sys_date;
				this.check_key = item.note;
				this.item_id = item.item_id;
				this.item_no = item.item_no;
				this.item_qty = item.qty;

				let key = 'pop_d_';

				for (var i = 0; i < this.list_detail.length; i++) {
					if (this.list_detail[i].row_num == item.row_num) {
						document.getElementById(key + item.row_num).style.background = '#92a4f3';
					} else {
						if (this.list_detail[i].row_num % 2 == 0) {
							document.getElementById(key + this.list_detail[i].row_num).style.background =
								'#fff';
						} else {
							document.getElementById(key + this.list_detail[i].row_num).style.background =
								'#f5f5f5';
						}
					}
				}

				switch (type) {
					case '_del':
						// console.log('删除操作！！！');
						this.fun_upd_item(type);
						break;
					case '_edit':
						// console.log('匹配操作！！！');
						this.load_item();
						break;
					default:
						break;
				}

			},
			fun_upd_item: function(type) {

				if (this.d_row_id == 0) {
					this.$message({
						message: '请选择要匹配的明细数据!',
						type: 'warning'
					});
					return;
				}

				if (this.sheet_exp == '') {
					this.$message({
						message: '请选择要编辑的业务单据!',
						type: 'warning'
					});
					return;
				}

				let d = [];

				d.push(this.sheet_exp);
				d.push(this.trans_store.val);
				d.push(this.item_id);
				d.push(this.item_qty);

				let r = (Math.random() + '').substring(0, 8);
				// console.log('编辑明细', d);
				let temp_data = '';
				temp_data = Method_Common('_store_car_d_build' + type, this.d_row_id, this.d_sys_date, d, r);

				this.$post(
					api.http_method, temp_data
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == 1) {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});

						this.refresh_child();

					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});
					}
				});

			},
			load_item: function() {
				this.element_loading = true;
				this.list_item = [];

				let r = (Math.random() + '').substring(0, 8);

				this.$post(
					api.http_method, Sel_page_and_length('exp_store_car_buildword', 1, 100, this.check_key,this.sheet_exp)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					if (res.length > 0) {
						// console.log(res);
						// console.log(res[0][0]);
						if (res[0][0].flag == '0') {
							this.$message({
								message: res[0][0].msg,
								type: 'warning'
							});
						} else {
							this.list_item = res[1];

							// console.log(this.list_item);
						}


					} else {
						this.$message({
							message: '没有匹配到数据!',
							type: 'warning'
						});
					}
				});
			},
			sel_row_check: function(item) {

				// console.log(this.parm);
				// 判断 obj.hasOwnProperty("key")
				//2、遍历Json串获取其属性
				this.item_id = item.row_id;
				this.item_no = item.item_no;
				this.item_name = item.item_name;

				let key = 'pop_s_';

				for (var i = 0; i < this.list_item.length; i++) {
					if (this.list_item[i].row_num == item.row_num) {
						document.getElementById(key + item.row_num).style.background = '#92a4f3';
					} else {
						if (this.list_item[i].row_num % 2 == 0) {
							document.getElementById(key + this.list_item[i].row_num).style.background =
								'#fff';
						} else {
							document.getElementById(key + this.list_item[i].row_num).style.background =
								'#f5f5f5';
						}
					}
				}

			},





		}
	};
</script>


<style scoped>
	.tab_header td {
		/* 纵向渐变 */
		/* Safari 5.1 - 6.0 */
		background: -webkit-linear-gradient(#3da5d9, #a2d2ff);
		/* Opera 11.1 - 12.0 */
		background: -o-linear-gradient(#3da5d9, #a2d2ff);
		/* Firefox 3.6 - 15 */
		background: -moz-linear-gradient(#3da5d9, #a2d2ff);
		/* 标准的语法（必须放在最后） */
		background: linear-gradient(#3da5d9, #a2d2ff);
		text-align: center;
		color: #000000;
		font-size: 14px;
		font-weight: 400;
	}

	.pop_bg {
		z-index: 998;
	}

	.pop_content {
		position: fixed;
		width: 80%;
		height: auto;
		left: 10%;
		top: 8%;
		/* background: #faf5f5; */
		/* background-color: azure; */
		background: rgb(195, 219, 250);
		border-radius: 5px;
		max-height: 80%;
		z-index: 999;
		overflow-y: auto;
		overflow-x: hidden;

		box-shadow: 0 0 5px 5px #0872a7;
	}

	.row-title {
		display: flex;
		align-items: flex-start;
	}

	.row-note {
		display: flex;
		flex-direction: column;
	}

	.row-note .row-item {
		display: flex;
		line-height: 24px;
		font-size: 14px;
		font-weight: bold;
		/* color: #ff0000 */
	}

	.row-line {
		display: flex;
		align-items: center;
	}


	.row-body {
		display: flex;
	}


	.row-left {
		display: inline-flex;
		/* padding-top: 30px; */
		padding-right: 6px;
		flex-direction: column;
	}

	.row-mid {
		display: inline-flex;
		flex-direction: column;
		align-content: flex-start;
		align-items: flex-start;
		background-color: #b1cad7;
		border-radius: 5px;
		/* padding: 6px; */
		padding-left: 6px;
		padding-right: 6px;
	}

	.mark-detail {
		display: inline-flex;
		flex-direction: column;
		margin-top: 8px;
	}

	.mark-detail-top label {
		display: inline-flex;
		vertical-align: middle;
		margin-right: 6px;
		min-width: 36px;
		line-height: 24px;
	}

	.mark-detail-top span {
		display: inline-flex;
		vertical-align: middle;
		margin-right: 2px;

		color: #ff0000;
		line-height: 24px;
	}

	.mark-detail-top input {
		display: inline-flex;
		vertical-align: middle;
		width: 64px;
		line-height: 24px;
	}

	/* .tab-row {
		display: flex;
		align-items: center;
		line-height: 32px;
		height: 32px;
	} */

	.row-right {

		display: inline-flex;
		/* padding-top: 30px; */
		padding-left: 6px;
		flex-direction: column;
	}

	.mark-key {
		color: #ff0000;
		font-weight: bold;
		font-size: 16px;
	}
</style>